import FormGroup from "../shared/containers/FormGroup"
import ContractInfoForm from "./ContractInfoForm"
import * as Yup from "yup";
import Input from "../shared/formInput/Input";
import axios from "../../utils/axios";
import useAuth from "../../hooks/useAuth";

const validationSchema = {
    first_name: Yup.string()
        .required("champ requis"),
    last_name: Yup.string()
        .required("champ requis"),
    birth_name: Yup.string()
        .required("champ requis"),
    phone_number: Yup.string()
        .matches(/^\d{10}$/, { message: "Format: 0655443322", excludeEmptyString: true })
        .required("Format: 0655443322"),
};



const ContractWithUserInfoForm = ({submitButtonChildren}) => {
    
    const {auth, setAuth} = useAuth();
    
    const userId = auth.user?.id
    const firstName = auth.user?.first_name
    const lastName = auth.user?.last_name
    const phoneNumber = !auth.user?.phone_number ? "" : auth.user?.phone_number
    
    const initialValues = {
        owner: userId,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
    };


    const requestActionHandler = async (values) => {

        const {first_name, last_name, phone_number, ...restOfValues} = values;

        try {
            await axios.patch(`user/${userId}`, {first_name, last_name, phone_number});
            await axios.post("contract", restOfValues);
            auth.user.has_contract = true;
            setAuth({...auth});
        } catch (error) {
            // console.error(error)
        }
    }

    return (
        <ContractInfoForm
            submitButtonChildren={submitButtonChildren}
            requestActionHandler={requestActionHandler}
            extraFields={initialValues}
            extraFieldsYupValidation={validationSchema}
        >
            <FormGroup multi>
                <Input
                    {...{
                        name: "first_name",
                        label: "Prénom",
                    }}
                />
                <Input
                    {...{
                        name: "last_name",
                        label: "Nom",
                    }}
                />
            </FormGroup>
            <FormGroup multi>
                <Input 
                    {...{
                        name: "phone_number",
                        label: "Téléphone",
                        helperText: "Format: 0655443322"
                    }}
                />
                <Input 
                    {...{
                        name: "birth_name",
                        label: "Nom de naissance",
                    }}
                />
            </FormGroup>
        </ContractInfoForm>
    );
};

export default ContractWithUserInfoForm;